import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../@core/auth/auth.service';
import { ReasonCode } from '../../modules/inventory/models/reason-code';
import { Transaction } from '../models/transaction';
import { TransactionReasonCode } from '../models/transactionReasonCode';
// import moment = require('moment-timezone');
import * as moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  protected basePath = '/';

  public wordList: TransactionReasonCode[] = [];
  public isLoading: boolean = true;

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public getTransactionReasonCodes(includeInactive: boolean = false) {

    let queryParameters = new HttpParams();

    if (includeInactive !== undefined && includeInactive !== null) {
      queryParameters = queryParameters.set('IncludeInactive', <any>includeInactive);
    }

    return this.httpClient.get<TransactionReasonCode[]>(`${this.basePath}/api/TransactionReasonCodes`,
      {
        params: queryParameters
      }
    );
  }

  public getTransactions(startDate: Date = null, endDate: Date = null) {

    let queryParameters = new HttpParams();

    endDate = moment(endDate).endOf('day').toDate();

    if (startDate && endDate) {
      queryParameters = queryParameters.set('startDate', startDate.toISOString());
      queryParameters = queryParameters.set('endDate', endDate.toISOString());
    }

    return this.httpClient.get<Transaction[]>(`${this.basePath}/api/Transactions`,
      {
        params: queryParameters
      }
    );
  }

  public getTransactionsByReason(lotId: number, reason: string) {

    let queryParameters = new HttpParams();

    queryParameters = queryParameters.set('lotId', lotId.toString());
    queryParameters = queryParameters.set('reason', reason);

    return this.httpClient.get<Transaction[]>(`${this.basePath}/api/Transactions/ByReason`,
      {
        params: queryParameters
      }
    );
  }

  public postTransactions(transactions: Transaction[]): Observable<any> {

    return this.httpClient.post<Transaction[]>(`${this.basePath}/api/Transactions/CreateMultiple`, transactions);
  }


  public deleteCode(id: number) {
    return this.httpClient.delete(`${this.basePath}/api/TransactionReasonCodes/${id}`);
  }


  public createCode(reasonCode: ReasonCode) {
    return this.httpClient.post<TransactionReasonCode[]>(`${this.basePath}/api/TransactionReasonCodes`, reasonCode);
  }


  public updateCode(reasonCode: ReasonCode) {
    return this.httpClient.put<TransactionReasonCode[]>(`${this.basePath}/api/TransactionReasonCodes/${reasonCode.id}`, reasonCode);
  }

}
